/* global axios */
import ApiClient from './ApiClient';

class ContactFollowUpsAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  getEnrollments(contactId) {
    return axios.get(`${this.url}/${contactId}/follow_up_enrollments`);
  }
}

export default new ContactFollowUpsAPI();
